// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3159":"596b6238","4087":"22d49477","4299":"72413106","5289":"22d49477","5437":"22d49477","6171":"22d49477"}[chunkId] + ".chunk.css";
};